import * as api from '../../../api/Api';

import {Dispatch} from "redux";

import Constants from './constants';

import {TeamResponse} from "../../../api/responses";
import {CouldNotFindTeamError} from "../../../api/errors";
import {ApiError} from "../../../api/errors/types";
import StartTimerResponse from "../../../api/responses/StartTimerResponse";
import CouldNotStartTimerError from "../../../api/errors/CouldNotStartTimerError";


/* Actions */
const createTeam = (team:string) => async (dispatch:any): Promise<TeamResponse> => {
    dispatch(createTeamCreatingPending(team))

    try {
        const response: TeamResponse = await api.createTeam(team);
        dispatch(createTeamCreatingSuccess(response));
        return Promise.resolve(response);
    } catch(e) {
        return Promise.reject(e);
    }
};

const fetchTeam = (team: string) => async (dispatch: Dispatch): Promise<TeamResponse> => {
    dispatch(createFetchTeamPending(team))

    try {
        const response = await api.fetchTeam(team);
        dispatch(createFetchTeamSuccess(response));
        return Promise.resolve(response);
    } catch(e) {
        if( e instanceof CouldNotFindTeamError) {
            dispatch(createFetchTeamError(team, e));
        }

        return Promise.reject(e);
    }
};

const startTimer = (team: string, duration: number, name: string) => async (dispatch: Dispatch): Promise<StartTimerResponse> => {
    dispatch(createStartTimerPending({ duration, name }));
    try {
        const startTimerResponse = await api.startTimer(team, duration, name);
        dispatch(createStartTimerSuccess(startTimerResponse));
        return Promise.resolve(startTimerResponse);
    } catch(e) {
        if(e instanceof CouldNotStartTimerError) {
            dispatch(createStartTimerError(e));
            return Promise.reject(e);
        }
    }

    return Promise.reject();
};

const stopTimer = (team: string) => async (dispatch: Dispatch): Promise<boolean> => {
    dispatch(createStopTimerPending(team));


    try {
        await api.stopTimer(team);
        dispatch(createStopTimerSuccess());
        return Promise.resolve(true);
    } catch(e) {
        const error = e.error.error;

        switch(error) {
            case 2002:
                break;
        }

        return Promise.reject();
    }

    return Promise.reject();

};



/* Action creators */
const timerStarted = (message: any) => (dispatch: Dispatch) => {
    dispatch(createStartTimerSocketSuccess(message));
};

const createStartTimerPending = (timer: { duration: number, name: string}) => ({
    payload: {
        timer
    },
    type: Constants.START_TIMER_PENDING,
});

const createStartTimerError = <T extends ApiError>(e: T) => ({
    error: e,
    type: Constants.START_TIMER_ERROR,
});

const createStartTimerSuccess = (response: StartTimerResponse) => ({
    payload: {
        timer: response.timer
    },
    type: Constants.START_TIMER_SUCCESS,
});

const createStartTimerSocketSuccess = (message: any) => ({
    payload: {
        timer: message
    },
    type: Constants.START_TIMER_SOCKET_SUCCESS,
});

const createStopTimerPending = (team: string) => ({
    payload: {
        team
    },
    type: Constants.STOP_TIMER_PENDING,
});

const createStopTimerSuccess = () => ({
    type: Constants.STOP_TIMER_SUCCESS,
});

const createFetchTeamPending = (team: string) => ({
    payload: {
        team
    },
    type: Constants.FETCH_TEAM_PENDING
});

const createFetchTeamSuccess = (team: TeamResponse) => ({
    payload: {
        team
    },
    type: Constants.FETCH_TEAM_SUCCESS
});

const createFetchTeamError = <T extends ApiError>(team: string, error:  T) => ({
    error,
    payload: {
        team
    },
    type: Constants.FETCH_TEAM_ERROR
});

const createTeamCreatingPending = (team: string) => ({
    payload: {
        team
    },
    type: Constants.CREATE_TEAM_PENDING,
});

const createTeamCreatingSuccess = (team: TeamResponse) => ({
    payload: {
        team
    },
    type: Constants.CREATE_TEAM_SUCCESS
});

export default {
    createTeam,
    fetchTeam,
    startTimer,
    stopTimer,
    timerStarted,
};



// WEBPACK FOOTER //
// ./src/redux/modules/team/actions.ts